export default __webpack_public_path__ + "static/media/01.77ff416c.jpg";